module.exports = __webpack_public_path__ + "static/img/logo_h.bc247418.png";